/**
 * Sanitizes a string for use in CSS selectors (IDs, classes).
 * Removes or replaces characters that are invalid in CSS selectors.
 *
 * @param {string} str - The string to sanitize
 * @returns {string} - A CSS-safe string
 */
export function sanitizeForSelector(str) {
  if (!str) return ''
  return str
    // Replace spaces with dashes
    .replace(/ /g, '-')
    // Replace apostrophes and quotes
    .replace(/[''"`]/g, '')
    // Replace parentheses
    .replace(/[()[\]{}]/g, '_')
    // Replace accented characters with base equivalents
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    // Remove any remaining invalid characters (keep alphanumeric, dash, underscore)
    .replace(/[^a-zA-Z0-9_-]/g, '_')
    // Clean up multiple consecutive dashes or underscores
    .replace(/[-_]+/g, '-')
    // Remove leading/trailing dashes
    .replace(/^-+|-+$/g, '')
}
